import { CheckCircle2 } from "lucide-react";
import PageHeader from "../components/PageHeader";
import FormFrame from "../components/FormFrame";
import EditorialMarquee from "../components/EditorialMarquee";
import { Reveal } from "../components/Reveal";
import { IMAGES, GHL_FORMS } from "../data/site";

const INCLUDES = [
  "Full wedding & event pricing",
  "Downloadable package brochure",
  "Ballroom capacity & floor plans",
  "Catering & bar menu options",
  "Available dates & seasonal offers",
];

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <PageHeader
        overline="Pricing & Brochure"
        titleLines={["Request Pricing", <>&amp; Wedding</>, <span key="i" className="italic text-gold">Package Brochure</span>]}
        subtitle="Tell us a little about your celebration and we'll send our full pricing details and wedding package brochure straight to your inbox."
        image={IMAGES.brochureCover}
        imageAlt="Vista Banquet Hall wedding brochure cover"
        testId="pricing-header"
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 pb-24 md:pb-32">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16 items-start">
          {/* left copy */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="overline text-gold">What You'll Receive</span>
              <h2 className="mt-5 font-serif text-3xl md:text-4xl font-light tracking-tight text-navy">
                Everything you need to plan with confidence.
              </h2>
            </Reveal>
            <ul className="mt-8 space-y-4">
              {INCLUDES.map((item, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <li className="flex items-start gap-3 text-navy/80 font-light">
                    <CheckCircle2 size={20} className="mt-0.5 text-gold shrink-0" />
                    {item}
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.4}>
              <div className="mt-10 border-l-2 border-gold/50 pl-6">
                <p className="font-serif text-2xl italic font-light text-navy/80">
                  “The moment we saw the brochure, we knew Vista was the one.”
                </p>
                <p className="mt-3 overline text-gold">Recently Wed at Vista</p>
              </div>
            </Reveal>
          </div>

          {/* right form */}
          <div className="lg:col-span-7">
            <FormFrame
              overline="Optin Form"
              title="Request Pricing & Brochure"
              subtitle="We'll respond within one business day."
              formId={GHL_FORMS.pricing.id}
              formName={GHL_FORMS.pricing.name}
              height={GHL_FORMS.pricing.height}
              testId="pricing-form"
            />
          </div>
        </div>
      </section>

      <EditorialMarquee items={["Request Pricing", "Wedding Brochure", "Tailored Packages", "Vista Banquet Hall"]} />
    </div>
  );
}
